module.exports = __webpack_public_path__ + "img/slide-img-02.b58cf397.png";